exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".empty-content-message[data-v-626045d1]{text-align:center;padding:40px}pre[data-v-626045d1]{background-color:#f8f9fa;padding:15px;border-radius:4px;border:1px solid #e9ecef}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-626045d1","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/main/member/APP/CompanyAppView.vue
// module id = 773
// module chunks = 6